// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light .v-expansion-panel[data-v-42f5619a]{background-color:transparent}.v-expansion-panel-content.pl-3 .v-expansion-panel-content__wrap[data-v-42f5619a]{padding-left:0!important}", ""]);
// Exports
module.exports = exports;
